import { render, staticRenderFns } from "./TitleDescriptionCardAnchor.vue?vue&type=template&id=5a311e4e&"
import script from "./TitleDescriptionCardAnchor.vue?vue&type=script&lang=js&"
export * from "./TitleDescriptionCardAnchor.vue?vue&type=script&lang=js&"
import style0 from "./TitleDescriptionCardAnchor.vue?vue&type=style&index=0&id=5a311e4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports